import { useQuery } from '@apollo/client';
import { CasesIdentityVerificationV1IndexContainerStaffUserCurrentDocument, CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment } from '../../../../../generated';
import { useOid } from '../../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../../shared/utils/queryOptions';
import { IdentityVerification } from './index';

interface CaseDetailsContainerProps {
  isApplicantSection?: boolean;
}

export const CaseDetailsContainer: React.FC<CaseDetailsContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data: staffUserData, loading: staffUserLoading, error: staffUserError } = useQuery(CasesIdentityVerificationV1IndexContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      error={staffUserError}
      loading={staffUserLoading}
      hasData={staffUserData?.staffUserCurrent}
      hasDataComponent={
        <IdentityVerification
          staffUserData={staffUserData?.staffUserCurrent as CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment}
          isApplicantSection={props.isApplicantSection}
        />
      }
    />
  );
};
